(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NewHeader"]) return;
  try {
    
  const navIcon = document.querySelector('.navIcon');
  const navbar = document.querySelector('.navbar');
  const Close = document.querySelector('.Close');
  const Appointment = document.querySelector('.book_an_appointment_mobile_view');
  const blackBG = document.querySelector('.blackBG');

  Appointment.addEventListener('click', () => {
    navbar.classList.remove('navbarActive');
    blackBG.classList.remove('blackBGActive');
  });
  navIcon.addEventListener('click', (e) => {
    e.preventDefault();
    navbar.classList.toggle('navbarActive');
    blackBG.classList.toggle('blackBGActive');
  });
  Close.addEventListener('click', () => {
    navbar.classList.remove('navbarActive');
    blackBG.classList.remove('blackBGActive');
  });
  blackBG.addEventListener('click', () => {
    navbar.classList.remove('navbarActive');
    blackBG.classList.remove('blackBGActive');
  });

  window.addEventListener('scroll', function () {
    const nav = document.querySelector('.mainheader');

    // Check for mobile and tablet widths (typically ≤ 1024px)
    if (window.innerWidth <= 1024) {
      if (window.scrollY > 0) {
        nav.classList.add('st-sticky');
      } else {
        nav.classList.remove('st-sticky');
      }
    } else {
      // Ensure sticky class is removed on larger screens
      nav.classList.remove('st-sticky');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
